<template>
    <div class="login-container">
      <div class="login-box">
        <div class="return" @click="back">×</div>
        <h2 class="title">用户登录</h2>
        
        <div class="toggle-buttons">
          <button 
            class="toggle-btn"
            :class="{ active: loginType === 'password' }"
            @click="loginType = 'password'"
          >
            密码登录
          </button>
          <button 
            class="toggle-btn"
            :class="{ active: loginType === 'code' }"
            @click="loginType = 'code'"
          >
            验证码登录
          </button>
        </div>
  
        <transition :name="transitionName" mode="out-in">
          <div class="form-group" key="password" v-if="loginType === 'password'">
            <div class="input-group">
              <input 
                v-model="form.phone"
                type="tel" 
                placeholder="请输入手机号"
                class="input-field"
              >
            </div>
            <div class="input-group">
              <input 
                v-model="form.password"
                type="password" 
                placeholder="请输入密码"
                class="input-field"
              >
            </div>
          </div>
  
          <div class="form-group" key="code" v-else>
            <div class="input-group">
              <input 
                v-model="form.phone"
                type="tel" 
                placeholder="请输入手机号"
                class="input-field"
              >
            </div>
            <div class="input-group code-group">
              <input 
                v-model="form.code"
                type="text" 
                placeholder="请输入验证码"
                class="input-field input-code"
              >
              <button 
                class="code-btn"
                :disabled="codeCountdown > 0"
                @click="sendCode"
              >
                {{ codeBtnText }}
              </button>
            </div>
          </div>
        </transition>
  
        <button class="submit-btn" @click="handleLogin">立即登录</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Login',
    data() {
      return {
        loginType: 'password', // password/code
        transitionName: 'slide',
        codeCountdown: 0,
        form: {
          phone: '',
          password: '',
          code: ''
        }
      }
    },
    computed: {
      codeBtnText() {
        return this.codeCountdown > 0 
          ? `${this.codeCountdown}秒后重发` 
          : '获取验证码'
      }
    },
    methods: {
      back(){
        this.$router.go(-1)
      },
      async sendCode() {
        if (!this.validatePhone()) return
        
        this.codeCountdown = 60
        const timer = setInterval(() => {
          if (this.codeCountdown <= 0) {
            clearInterval(timer)
            return
          }
          this.codeCountdown--
        }, 1000)
        
        // 调用发送验证码接口
        try {
          // await api.sendCode(this.form.phone)
        } catch (error) {
          console.error(error)
        }
      },
  
      validatePhone() {
        const reg = /^1[3-9]\d{9}$/
        if (!reg.test(this.form.phone)) {
          this.$message.error('手机号格式不正确')
          return false
        }
        return true
      },
  
      async handleLogin() {
        if (!this.validatePhone()) return
        
        // 表单验证
        if (this.loginType === 'password' && !this.form.password) {
          this.$message.error('请输入密码')
          return
        }
        if (this.loginType === 'code' && !this.form.code) {
          this.$message.error('请输入验证码')
          return
        }
  
        // 调用登录接口
        try {
          // const res = await api.login({ 
          //   ...this.form,
          //   loginType: this.loginType
          // })
          
          // 模拟登录成功
          const userInfo = {
            phone: this.form.phone,
            token: 'mock_token'
          }
          
          // 存储用户信息
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          this.$store.commit('setUserInfo', userInfo)
          
          // 返回原页面
          this.$router.go(-1)
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .login-container {
    position: absolute;
    left: 0;
    top:0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 90vh;
    background: linear-gradient(135deg, #00000000 0%, #00000000 100%);
  }
  
  .login-box {
    position: relative;
    background: white;
    padding: 5vw;
    border-radius: 4vw;
    box-shadow: 0 3vw 3vw rgba(0,0,0,0.1);
    width: 85vw;
  }
  .return{
    background-color: rgb(231, 181, 161);
    border: 1px solid #ddd;
    position: absolute;
    width: 8vw;
    height: 8vw;
    border-radius: 25%;
    text-align: center;
    line-height: 8vw;
    font-size: 20px;
    font-family: "华文中宋";
    right: 2vw;
    top: 2vw;
  }
  .title {
    text-align: center;
    color: #2c3e50;
    margin-bottom: 30px;
  }
  
  .toggle-buttons {
    display: flex;
    margin-bottom: 30px;
    border-bottom: 1px solid #eee;
  }
  
  .toggle-btn {
    flex: 1;
    padding: 12px;
    border: none;
    background: none;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    transition: all 0.3s;
    
    &.active {
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
  
    &:hover {
      color: #66b1ff;
    }
  }
  
  .input-group {
    margin-bottom: 20px;
    
    &.code-group {
      display: flex;
 
      justify-content:center;
      align-items:center;
      gap: 10px;
    }
  }
  
  .input-field {
    width: 85%;
    height: 40px;
    padding: 1vw;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.3s;
  
    &:focus {
      border-color: #409eff;
      outline: none;
    }
  }
  .input-code{
    width: 52% !important;
  }
  .code-btn {
    width: 31% !important;
    height: 40px;
    padding: 1vw;
    flex-shrink: 0;
    background: #409eff;
    color: rgb(255, 255, 255);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    &:disabled {
      background: #a0cfff;
      cursor: not-allowed;
    }
  }
  
  .submit-btn {
    width: 80%;
    padding: 12px;
    background: #409eff;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
  
    &:hover {
      background: #66b1ff;
    }
  }
  
  /* 切换动画 */
  .slide-enter-active, .slide-leave-active {
    transition: all 0.3s ease;
  }
  .slide-enter-from {
    opacity: 0;
    transform: translateX(-20px);
  }
  .slide-leave-to {
    opacity: 0;
    transform: translateX(20px);
  }
  </style>